import { ref } from 'vue';

export function useZSDialog() {
  const dialogRef = ref(null);
  
  const show = (config) => {
    if (dialogRef.value && dialogRef.value.show) {
      dialogRef.value.show(config);
    }
  };
  
  const hide = () => {
    if (dialogRef.value && dialogRef.value.hide) {
      dialogRef.value.hide();
    }
  };
  
  return { dialogRef, show, hide };
}
